<div class="max-w-[1920px] mx-auto">
  <div class="base-page-container">
    <div class="page-header">
      <div class="title" [wunEditableText]="'collector_home.header.title'" [fallback]="fallbacks.header.title">
        Discover art that speaks to you    </div>
      <div class="sub-title" [wunEditableText]="'collector_home.header.subtitle'" [fallback]="fallbacks.header.subtitle">
        Explore and collect curated contemporary artworks from artists worldwide
      </div>
    </div>

    <div class="py-12">
      <button wunButton primary class="!px-16" (click)="scrollToElement(formDivElement)">
        <span [wunEditableText]="'collector_home.joinButton'" [fallback]="fallbacks.joinButton">Join Now</span>
      </button>
    </div>

    <div class="box-header" [wunEditableText]="'collector_home.whyJoin.title'" [fallback]="fallbacks.whyJoin.title">
      Why join Wundart?
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 w-full xl:grid-cols-4 lg:grid-cols-2 gap-8 mt-8">
      <!-- ARTIST -->
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'collector_home.whyJoin.features.0.title'" [fallback]="fallbacks.whyJoin.features[0].title">
          Personalized art recommendations
        </div>
        <div class="box-content" [wunEditableText]="'collector_home.whyJoin.features.0.content'" [fallback]="fallbacks.whyJoin.features[0].content">
          Wundart’s Curatorial Team and sophisticated algorithm provide tailor-made suggestions that match your artistic taste. Discover artworks and artists that truly resonate with your personal preferences.        </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'collector_home.whyJoin.features.1.title'" [fallback]="fallbacks.whyJoin.features[1].title">
          Direct connection with artists
        </div>
        <div class="box-content" [wunEditableText]="'collector_home.whyJoin.features.1.content'" [fallback]="fallbacks.whyJoin.features[1].content">
          Contact artists directly through Wundart’s built-in messaging system. Build relationships, ask questions, and engage with the creators of the artworks you love.
        </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'collector_home.whyJoin.features.2.title'" [fallback]="fallbacks.whyJoin.features[2].title">
          Curated virtual collections
        </div>
        <div class="box-content" [wunEditableText]="'collector_home.whyJoin.features.2.content'" [fallback]="fallbacks.whyJoin.features[2].content">
          Showcase the artworks you’ve purchased in a virtual collection on your profile. Track and display your art in a professional, organized way, and share it with other art lovers.
        </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'collector_home.whyJoin.features.3.title'" [fallback]="fallbacks.whyJoin.features[3].title">
          Free collector profile
        </div>
        <div class="box-content" [wunEditableText]="'collector_home.whyJoin.features.3.content'" [fallback]="fallbacks.whyJoin.features[3].content">
          At Wundart, we believe that discovering and collecting contemporary art should be accessible to everyone. That’s why creating your collector profile is completely free.
        </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'collector_home.whyJoin.features.4.title'" [fallback]="fallbacks.whyJoin.features[4].title">
          Certified authenticity of artworks        </div>
        <div class="box-content" [wunEditableText]="'collector_home.whyJoin.features.4.content'" [fallback]="fallbacks.whyJoin.features[4].content">
          Every piece comes with a certificate of authenticity, guaranteeing provenance and assuring the value of your purchase. Collect with confidence knowing your artworks are genuine.        </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'collector_home.whyJoin.features.5.title'" [fallback]="fallbacks.whyJoin.features[5].title">
          Trusted and transparent purchase process
        </div>
        <div class="box-content" [wunEditableText]="'collector_home.whyJoin.features.5.content'" [fallback]="fallbacks.whyJoin.features[5].content">
          Wundart guides you step by step through secure payments via PayPal or bank transfer. Delivery fees and timelines are clearly communicated before final purchase, ensuring full transparency.
        </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'collector_home.whyJoin.features.6.title'" [fallback]="fallbacks.whyJoin.features[6].title">
          Safe and insured delivery        </div>
        <div class="box-content" [wunEditableText]="'collector_home.whyJoin.features.6.content'" [fallback]="fallbacks.whyJoin.features[6].content">
          We ensure professional handling and full insurance of your artworks from gallery to your door. Receive your purchases safely and efficiently, anywhere in the covered destinations.        </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title" [wunEditableText]="'collector_home.whyJoin.features.7.title'" [fallback]="fallbacks.whyJoin.features[7].title">
          Flexible return policy        </div>
        <div class="box-content" [wunEditableText]="'collector_home.whyJoin.features.7.content'" [fallback]="fallbacks.whyJoin.features[7].content">
          You can request a refund within 14 days of receiving your artwork if needed. After this period, payment will be processed to the artist and returns will no longer be possible.        </div>
      </div>
    </div>


    <div class="w-full p-10 text-center flex justify-center">
      <button wunButton primary class="!px-16" (click)="scrollToElement(formDivElement)">
        <span [wunEditableText]="'collector_home.joinButton'" [fallback]="fallbacks.joinButton">Join Now</span>
      </button>
    </div>

  </div>

  <div class="bg-black w-full p-8 md:p-12">
    <div class="max-w-[1200px] mx-auto flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-10">
      <div class="font-thin text-white text-xl md:text-3xl lg:text-4xl text-center lg:text-left" [wunEditableText]="'collector_home.questions.title'" [fallback]="fallbacks.questions.title">
        Have more questions?
      </div>
      <div class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded" (click)="scrollToElement(faqContainer)">
          <span [wunEditableText]="'collector_home.questions.faqButton'" [fallback]="fallbacks.questions.faqButton">Check out our FAQ</span>
        </a>
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded whitespace-nowrap" routerLink="/exchange-refund-policy">
          <span [wunEditableText]="'collector_home.questions.exchangePolicy'" [fallback]="fallbacks.questions.exchangePolicy">Exchange & Refund Policy</span>
        </a>
      </div>
    </div>
  </div>

  <div class="base-page-container">

    <div class="box-header text-xl py-8" #formDivElement [wunEditableText]="'collector_home.joinNow.title'" [fallback]="fallbacks.joinNow.title">
      Join Now
    </div>

    <div class="text-xl font-thin" [wunEditableText]="'collector_home.joinNow.description'" [fallback]="fallbacks.joinNow.description">

      Create your personal account to save your favorite artworks, receive email updates and get exclusive offers.    </div>

    <div class="mt-14">
      <form [formGroup]="signupForm" class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[800px] m-auto">
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Name" formControlName="firstName">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Surname" formControlName="lastName">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Email" type="email" formControlName="email">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Phone number" formControlName="phone">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Country" formControlName="country">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="City" formControlName="city">
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black placeholder="Username" formControlName="username">
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black placeholder="Your password" type="password" formControlName="password">
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black placeholder="Confirm your password" type="password" formControlName="confirmPassword">
        </div>

        <div  class="col-span-2 flex flex-col gap-2">
          <div class="col-span-2">

            <wun-checkbox label="By registering, you agree to our Terms of Service and Privacy Policy." formControlName="termsAndConditions">
              <ng-template #label>
                <span [wunEditableText]="'collector_home.form.termsPrefix'" [fallback]="fallbacks.form.termsPrefix">By registering, you agree to our</span>
                <a href="/terms-and-conditions.pdf" target="_blank">
                  <span [wunEditableText]="'collector_home.form.termsLink'" [fallback]="fallbacks.form.termsLink">Terms of Service</span>
                </a>
                <span [wunEditableText]="'collector_home.form.termsAnd'" [fallback]="fallbacks.form.termsAnd">and</span>
                <a href="/privacy-policy.pdf" target="_blank">
                  <span [wunEditableText]="'collector_home.form.privacyLink'" [fallback]="fallbacks.form.privacyLink">Privacy Policy</span>
                </a>.
              </ng-template>
            </wun-checkbox>
          </div>
          <div>

            <wun-checkbox label="" formControlName="newsletterConsent">
              <ng-template #label>
                <span [wunEditableText]="'collector_home.form.newsletterConsent'" [fallback]="fallbacks.form.newsletterConsent">I agree to receive updates, special offers and news from Wundart.</span>
              </ng-template>
            </wun-checkbox>
          </div>
        </div>


        <div class="py-6 w-full flex justify-center col-span-2">
          <button wunButton primary class="!px-16" type="submit" (click)="signup()">
            <span [wunEditableText]="'collector_home.form.send'" [fallback]="fallbacks.form.send">Send</span>
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="bg-black w-full p-8 md:p-12" #faqContainer>
    <div class="max-w-[1200px] mx-auto flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-10">
      <div class="font-thin text-white text-xl md:text-3xl lg:text-4xl text-center lg:text-left" [wunEditableText]="'collector_home.questions.title'" [fallback]="fallbacks.questions.title">
        Have more questions?
      </div>
      <div class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded" (click)="scrollToElement(faqContainer)">
          <span [wunEditableText]="'collector_home.questions.faqButton'" [fallback]="fallbacks.questions.faqButton">Check out our FAQ</span>
        </a>
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded whitespace-nowrap" routerLink="/exchange-refund-policy">
          <span [wunEditableText]="'collector_home.questions.exchangePolicy'" [fallback]="fallbacks.questions.exchangePolicy">Exchange & Refund Policy</span>
        </a>
      </div>
    </div>
  </div>

  <div class="base-page-container flex flex-col gap-4 max-w-[1510px] m-auto">

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q1.question'" [fallback]="fallbacks.faq.q1.question">
              HOW DOES WUNDART WORK FOR A COLLECTOR?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q1.content'" [fallback]="fallbacks.faq.q1.content">Wundart provides a highly efficient and trusted e-commerce service that connects artists and potential buyers. Our Curatorial Team and a highly sophisticated algorithm ensure that you always receive tailor-made recommendations that fit your artistic criteria.</p>
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q1.content2'" [fallback]="fallbacks.faq.q1.content2">Thanks to our partnership with Mailboxes Etc. Wundart is able to deliver your chosen artworks right at your door with a highly efficient and trusted delivery service.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q2.question'" [fallback]="fallbacks.faq.q2.question">
              HOW DOES THE COLLECTOR PROFILE WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q2.content'" [fallback]="fallbacks.faq.q2.content">As a potential buyer or simply an art lover, once you create your "Collector" profile, you will be able to receive custom suggestions of artists and artworks based on your personal tastes, follow and contact artists directly, create a wishlist of artworks you wish to purchase and showcase on your profile the artworks you have already bought with Wundart in a virtual collection.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q3.question'" [fallback]="fallbacks.faq.q3.question">
              IS THE COLLECTOR PROFILE FREE?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q3.content'" [fallback]="fallbacks.faq.q3.content">Yes, the collector profile is entirely free and includes all the aforementioned features.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q4.question'" [fallback]="fallbacks.faq.q4.question">
              HOW DOES THE PURCHASE PROCESS WORK ON WUNDART?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q4.content'" [fallback]="fallbacks.faq.q4.content">Once you have selected your chosen artwork Wundart will guide you through the payment process.</p>
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q4.content2'" [fallback]="fallbacks.faq.q4.content2">The platform accepts payments with PayPal and bank transfers.</p>
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q4.content3'" [fallback]="fallbacks.faq.q4.content3">The artwork will be issued with a certificate of authenticity that will ensure the provenance of the artwork.</p>
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q4.content4'" [fallback]="fallbacks.faq.q4.content4">The delivery time will be estimated before the final purchase and will be available beforehand to ensure maximum transparency. The delivery fees will be charged to the buyer and always included in the final price of the order.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q5.question'" [fallback]="fallbacks.faq.q5.question">
              IS THERE A RETURN POLICY FOR PURCHASED ITEMS?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q5.content'" [fallback]="fallbacks.faq.q5.content">Yes, Wundart provides a refund of a purchased item within 14 days from its purchase date, after which the payment to the artist will be processed and it won't be possible to return the item anymore.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q6.question'" [fallback]="fallbacks.faq.q6.question">
              ARE THE SHIPPED ITEMS ENSURED?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q6.content'" [fallback]="fallbacks.faq.q6.content">Yes, Wundart's partner Mailboxes Etc. provides a full insurance for the artworks that they take charge of.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q7.question'" [fallback]="fallbacks.faq.q7.question">
              CAN I CONTACT ARTISTS DIRECTLY?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q7.content'" [fallback]="fallbacks.faq.q7.content">Yes, Wundart has an efficient built-in system of messaging that allows the artists and the collectors to be directly connected.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q8.question'" [fallback]="fallbacks.faq.q8.question">
              WHERE IS WUNDART AVAILABLE FOR POTENTIAL BUYERS?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q8.content'" [fallback]="fallbacks.faq.q8.content">At the moment Wundart's services are available for all potential buyers within the European Union, Switzerland and the United Kingdom. More areas of the world will be covered very soon.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div [wunEditableText]="'collector_home.faq.q9.question'" [fallback]="fallbacks.faq.q9.question">
              WHY SHOULD I BUY ARTWORKS WITH WUNDART?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4" [wunEditableText]="'collector_home.faq.q9.content'" [fallback]="fallbacks.faq.q9.content">Wundart provides a high quality service that is tailored for your needs and provides transparency and efficiency in every step of the buying process. The complete insurance of the artworks, the high level and trusted shipping service and the possibility to contact artists directly makes for a truly unique experience for an art collector.</p>
      </div>
    </mat-expansion-panel>


    <newsletter-subscribe/>

  </div>

</div>


